var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.997,
    height: 12,
    viewBox: "0 0 10.997 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9640",
    "data-name": "Trac\\xE9 9640",
    d: "M27.884,12a.5.5,0,0,1-.3-.1l-2-1.5a.5.5,0,0,1-.2-.4V7.19L21.876,3.243A1.95,1.95,0,0,1,23.334,0h7.1A1.95,1.95,0,0,1,31.89,3.244L28.384,7.19V11.5A.5.5,0,0,1,27.884,12Zm-1.5-2.25,1,.75V7a.5.5,0,0,1,.127-.332L31.144,2.58A.95.95,0,0,0,30.434,1h-7.1a.95.95,0,0,0-.71,1.579l3.635,4.089A.5.5,0,0,1,26.384,7Z",
    transform: "translate(-21.385)",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtat);
export default __webpack_public_path__ + "static/media/Etat.b2d9b31f310433004469766f75ea8c70.svg";
export { ForwardRef as ReactComponent };